import React from 'react';
//import Conexion from './../conexion/conexion';
import Header from '../elementos/basicos/Header';

import CabeceraPol from '../elementos/basicos/CabezeraPol';
import Footer from '../elementos/basicos/Footer';
import styled from 'styled-components';

//Objeto principal el cual nos mostrará la politíca de cookies
const PoliticaDeCookies = () => {


    return (
        <>
            <Header noTelEmail="true" />


            <CabeceraPol
                Titulo="Política de cookies"

            ></CabeceraPol>

            <PoliticaDiv>

                <h3 data-fontsize="16" data-lineheight="24px">
                    <strong><em><u>¿QUÉ ES UNA COOKIE?</u></em></strong>
                </h3>
                <p>
                    <em>Este sitio web utiliza cookies y/o tecnologías similares que almacenan y recuperan información cuando navegas. En general, estas tecnologías pueden servir para finalidades muy diversas, como, por ejemplo, reconocerte como usuario, obtener información sobre tus hábitos de navegación o personalizas la forma en la que se muestra el contenido. Los usos concretos que hacemos de estas tecnologías se describen a continuación. </em>
                </p>
                <h3 data-fontsize="16" data-lineheight="24px"><strong><em><u>¿QUIÉN UTILIZA LA INFORMACIÓN DE LAS COOKIES?</u></em></strong></h3>
                <p><strong>LAE FORMACIÓN PROGRAMADA, S.L.</strong><br />B20910121<br />Calle Juan F. Gilisagasti 2 – oficina 215, 20.018 Donostia – San Sebastián (Gipuzkoa)</p>
                <h3 data-fontsize="16" data-lineheight="24px"><strong><em><u>¿QUÉ TIPOS DE COOKIES EXISTEN?</u></em></strong></h3>
                <p>
                    <em>Las Cookies pueden clasificarse, en virtud de sus características propias, dentro de diversas categorías.</em>
                </p>
                <p>
                    <em>1 – Según la entidad que la gestione:</em>
                </p>
                <ul>
                    <li>
                        <em>Cookies propias: Son aquellas que se envían a tu ordenador y son gestionadas exclusivamente por nosotros para el mejor funcionamiento del Sitio Web.</em>
                    </li>
                    <li>
                        <em>Cookies de terceros: Son aquellas que se envían a tu ordenador y no son gestionadas por nosotros sino por una tercera entidad. </em>
                    </li>
                </ul>
                <p>
                    <em>2 – Según el plazo de tiempo que permanecen activadas: </em>
                </p>
                <ul>
                    <li>
                        <em>Cookies de sesión: Este tipo de cookies recaban y almacenan datos únicamente mientras el Usuario accede al Sitio Web. </em>
                    </li>
                    <li>
                        <em>Cookies persistentes: Mediante este tipo de cookies los datos siguen almacenados y pueden ser accedidos y tratados durante el periodo definido por el responsable de la cookie, y puede ir de unos minutos a varios años.</em>
                    </li>
                </ul>
                <p>
                    <em>3 – Según la finalidad:</em>
                </p>
                <ul>
                    <li>
                        <em>Cookies técnicas: Son aquellas que permiten al usuario la navegación a través del sitio web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que el mismo ofrece, como por ejemplo, controlar el  tráfico  y  la comunicación   de   datos,   identificar   la   sesión,   acceder   a   partes   de   acceso restringido, recordar los elementos que integran un pedido,  realizar el proceso de compra  de  un  pedido,  realizar  la  solicitud  de  inscripción  o  participación  en  un evento,   utilizar   elementos   de   seguridad   durante   la   navegación,   almacenar contenidos para la difusión de videos o sonido o compartir contenidos a través de redes sociales.</em>
                    </li>
                    <li>
                        <em>Cookies de personalización: Son aquéllas que permiten al usuario accede al servicio con algunas características de carácter general predefinidas, como por ejemplo el idioma, la configuración regional desde donde accede al servicio, etc. </em>
                    </li>
                    <li>
                        <em>Cookies de análisis: Son aquéllas que permiten al responsable de las mismas, el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que  están    La  información  recogida  mediante  este  tipo  de  cookies  se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma y para  la  elaboración  de  perfiles  de  navegación  de  los  usuarios  de  dichos  sitios, aplicaciones y plataformas, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</em>
                    </li>
                    <li>
                        <em>Cookies publicitarias: Son aquéllas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, se haya incluido en el sitio web, aplicación o plataforma desde la que presta el servicio solicitado en base a los criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.</em>
                    </li>
                    <li>
                        <em>Cookies de publicidad comportamental: Son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en su página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.</em>
                    </li>
                </ul>
                <h3 data-fontsize="16" data-lineheight="24px">
                    <strong><em><u>¿QUÉ TIPOS DE COOKIES UTILIZA ESTE SITIO WEB?</u></em></strong>
                </h3>
                <p>
                    <em>A continuación, se especifican las cookies en concreto empleadas en el presente Sitio Web:</em>
                </p>
                <DivTabla >
                    <strong>Necesarias (3)  </strong>
                    <p >Las cookies necesarias ayudan a hacer una página web utilizable activando funciones básicas como la navegación en la página y el acceso a áreas seguras de la página web. La página web no puede funcionar adecuadamente sin estas cookies.</p>

                    <Tabla>

                        <colgroup>
                            <col />
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col" dir="ltr">Nombre</th>
                                <th scope="col" dir="ltr">Proveedor</th>
                                <th scope="col" dir="ltr">Propósito</th>
                                <th scope="col" dir="ltr">Caducidad</th>
                                <th scope="col" dir="ltr">Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td >CookieConsent</td>
                                <td ><a target="_blank" rel="noopener noreferrer nofollow" href="https://www.cookiebot.com/goto/privacy-policy/" title="la política de privacidad de Cookiebot">Cookiebot</a></td>
                                <td >Almacena el estado de consentimiento de cookies del usuario para el dominio actual</td>
                                <td >1 año</td>
                                <td >HTTP Cookie</td>
                            </tr>
                            <tr>
                                <td >rc::a</td>
                                <td ><a target="_blank" rel="noopener noreferrer nofollow" href="https://policies.google.com/privacy" title="la política de privacidad de Google">Google</a></td>
                                <td >Esta cookie se utiliza para distinguir entre humanos y bots. Esto es beneficioso para la web con el objeto de elaborar informes válidos sobre el uso de su web.</td>
                                <td >Persistent</td>
                                <td >HTML Local Storage</td>
                            </tr>
                            <tr>
                                <td >rc::c</td>
                                <td ><a target="_blank" rel="noopener noreferrer nofollow" href="https://policies.google.com/privacy" title="la política de privacidad de Google">Google</a></td>
                                <td >Esta cookie se utiliza para distinguir entre humanos y bots.</td>
                                <td >Session</td>
                                <td >HTML Local Storage</td>
                            </tr>
                        </tbody>
                    </Tabla>

                </DivTabla>

                <DivTabla>
                    <strong>Preferencias (1)</strong>
                    <p >Las cookies de preferencias permiten a la página web recordar información que cambia la forma en que la página se comporta o el aspecto que tiene, como su idioma preferido o la región en la que usted se encuentra.</p>

                    <Tabla >

                        <colgroup>
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '35%' }} />
                            <col style={{ width: '15%' }} />
                            <col style={{ width: '10%' }} />
                        </colgroup>
                        <thead>

                            <tr>
                                <th scope="col" dir="ltr">Nombre</th>
                                <th scope="col" dir="ltr">Proveedor</th>
                                <th scope="col" dir="ltr">Propósito</th>
                                <th scope="col" dir="ltr">Caducidad</th>
                                <th scope="col" dir="ltr">Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td >ssupp.vid</td>
                                <td >widget-v2.smartsuppcdn.com</td>
                                <td >Necesaria para la funcionabilidad del chat en la web.</td>
                                <td >6 meses</td>
                                <td >HTTP Cookie</td>
                            </tr>
                        </tbody>
                    </Tabla>
                </DivTabla>

                <DivTabla>
                    <strong>Preferencias (1)</strong>
                    <p >Las cookies de preferencias permiten a la página web recordar información que cambia la forma en que la página se comporta o el aspecto que tiene, como su idioma preferido o la región en la que usted se encuentra.</p>

                    <Tabla >

                        <colgroup>
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '20%' }} />
                            <col style={{ width: '35%' }} />
                            <col style={{ width: '15%' }} />
                            <col style={{ width: '10%' }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col" dir="ltr">Nombre</th>
                                <th scope="col" dir="ltr">Proveedor</th>
                                <th scope="col" dir="ltr">Propósito</th>
                                <th scope="col" dir="ltr">Caducidad</th>
                                <th scope="col" dir="ltr">Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td >ssupp.vid</td>
                                <td >widget-v2.smartsuppcdn.com</td>
                                <td >Necesaria para la funcionabilidad del chat en la web.</td>
                                <td >6 meses</td>
                                <td >HTTP Cookie</td>
                            </tr>
                        </tbody>
                    </Tabla>
                </DivTabla>




                <p>
                    <em>Esta tabla puede ser actualizada conforme a las cookies empleadas en cada momento. Te aconsejamos que consulte nuestra Política de Cookies de forma regular. </em>
                </p>
                <h3 data-fontsize="16" data-lineheight="24px">
                    <strong><em><u>¿SE REALIZAN TRANFERENCIAS DE DATOS A TERCEROS PAÍSES?</u></em></strong>
                </h3>
                <p>
                    <em>Puedes informarte de las transferencias a terceros países que, en su caso, realizan los terceros identificados en esta política de cookies en sus correspondientes políticas (Ver los enlaces facilitados en la tabla anterior, en el apartado de cookies de terceros).</em>
                </p>
                <h3 data-fontsize="16" data-lineheight="24px">
                    <strong><em><u>¿CÓMO DESHABILITAR Y BLOQUAR COOKIES? </u></em></strong>
                </h3>
                <p>
                    <em>Te informamos que, en cualquier caso, puedes deshabilitar o bloquear las cookies activando la configuración de tu navegador, permitiéndote rechazar la instalación de todas o algunas de las cookies. En caso de no permitir la instalación de cookies es posible que no puedas acceder a algunas de las funcionalidades del presente sitio web, y por tanto, tu experiencia como usuario en el sitio web resulte menos satisfactoria.</em>
                </p>
                <p>
                    <em>Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo mediante la configuración de las opciones del navegador instalado en tu ordenador. Para más información sobre cómo ajustar sus configuraciones de cookies en los siguientes navegadores, te remitimos al enlace pertinente:</em> <a href="http://support.google.com/chrome/bin/answer.py?hl=en&amp;answer=9564">Chrome</a>, <a href="https://support.apple.com/kb/PH19214?viewlocale=es_ES&amp;locale=es_ES">Safari </a><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias?redirectlocale=es&amp;redirectslug=habilitar-y-deshabilitar-cookies-que-los-sitios-we">Firefox</a>, <a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies">Internet Explorer</a>, <a href="http://help.opera.com/Windows/11.50/es-ES/cookies.html">Opera</a>.
                </p>
                <h3 data-fontsize="16" data-lineheight="24px">
                    <strong><em><u>¿QUÉ DERECHOS TIENES SOBRE LOS DATOS PERSONALES APORTADOS?</u></em></strong>
                </h3>
                <p>
                    <em>Como usuario, puedes ejercitar los siguientes derechos: </em>
                </p>
                <ul>
                    <li>
                        <em>Derecho de acceso: Tienes derecho a obtener por parte de la empresa confirmación de si se están tratando o no tus datos personales que, y en su caso, qué datos trata.</em>
                    </li>
                    <li>
                        <em>Derecho de rectificación: Tienes derecho a obtener por parte de la empresa, la rectificación de los datos personales inexactos que te conciernen. En la solicitud de rectificación deberás indicar los datos que deseas que se modifiquen.</em>
                    </li>
                    <li>
                        <em>Derecho de oposición: Tienes derecho a oponerte en cualquier momento, por motivos relacionados con tu situación particular, a que datos personales que te conciernan sean objeto de un tratamiento basado en el interés legítimo de la empresa. En ese caso, la empresa dejará de tratar los datos personales, salvo que acreditemos motivos legítimos imperiosos para el tratamiento que prevalezcan sobre tus intereses, derechos y libertades, o para la formulación, el ejercicio o la defensa de reclamaciones.</em>
                    </li>
                    <li>
                        <em>Derecho de supresión: Tienes derecho a obtener por parte de la empresa, la supresión de los datos personales que te conciernan.</em>
                    </li>
                    <li>
                        <em>Derecho a la portabilidad de los datos: Tienes derecho a que la empresa transfiera tus datos personales a otro responsable del tratamiento. Solo es posible ejercer este derecho cuando el tratamiento esté basado en la ejecución de un contrato o en tu consentimiento y el tratamiento se realice por medios automatizados.</em>
                    </li>
                    <li>
                        <em>Derecho a la limitación del tratamiento: Tienes derecho a solicitarnos que suspendamos el tratamiento de tus datos cuando: impugnes la exactitud de los datos, mientras la empresa verifica dicha exactitud; hayas ejercido el derecho de oposición al tratamiento de tus datos, mientras que se verifica si los motivos legítimos de la empresa prevalecen sobre los tuyos como interesado.</em>
                    </li>
                    <li>
                        <em>Derecho a no ser objeto de decisiones individuales automatizadas, incluida la elaboración de perfiles: Tienes derecho a no ser objeto de una decisión basada únicamente en el tratamiento automatizado, incluida la elaboración de perfiles, que produzca efectos jurídicos o te afecte significativamente de modo similar.</em>
                    </li>
                </ul>
                <p>
                    <em>En cualquier momento, podrás ejercitar estos Derechos, mediante un escrito y acreditando tu personalidad dirigido al responsable del tratamiento, a la dirección que aparece más arriba.</em>
                </p>
                <p>
                    <em>Además, podrás presentar una reclamación ante la autoridad de control, en este caso, la Agencia Española de Protección de Datos, si consideras que el tratamiento de datos personales infringe la legislación aplicable.</em>
                </p>
            </PoliticaDiv >
            <Footer />





        </>
    );
}


const PoliticaDiv = styled.div`
    
    margin: 2% 20% 0% 20%;
    font-family: 'Roboto';
    font-style: italic;
    p,ul{
        color: #7A7A7A;
        font-size: 14px;
    }
    
    h3{
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 1.4;
        text-align: center;
    }
    
    a{
        color: black;
        text-decoration: none;
    }

    a:hover{
        color: #23527c;
    }
`

const DivTabla = styled.div`
     border: 1px solid black;
     margin-bottom: 20px; 
`

const Tabla = styled.table`
   
    border-collapse: collapse; 
    width: 100%; 
    
    color: #7a7a7a;
    font-family: 'Roboto';
    font-style: normal;
    padding-left: 10px;
    
    td {
        border-bottom: 1px solid black; 
        padding: 8px; 
        text-align: left; 
    }

    th, td {
        padding: 8px 10px; 
    }

    thead th {
        padding: 8px 10px;
    }

`;




export default PoliticaDeCookies;
